/*
* Display available lookup tables
*/

import '../common/bootstrap/bootstrapcolxl.css';

import * as _ from 'lodash';
import * as React from 'react';
import { Button, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as MutateActions from '../actions/mutate';
import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import * as LK from '../config/apilookupkeys';
import * as ReduxQueries from '../queries';

export interface ILookupTablesProps extends AppComp.IAppComponentProps {
    regionDetailRegion?: any;
    regionId?: any;
    users?: any;
    offices?: any;
    updateRegion?: any;
    navigateTo?: any;
}

export interface ILookupTablesState extends AppComp.IAppComponentState {
    formChanges?: any;
}

class LookupTables extends AppComp.AppComponent<ILookupTablesProps, ILookupTablesState> {
    public originalFormDataCache = {};
    public kendoFormWhiteBoxSectionProps = {};

    public constructor(props: ILookupTablesProps) {
        super(props, 'app.lookup-tables.');

        this.state = {
            formChanges: {},
        };
    }

    public componentDidUpdate() {
        let resetFormData = this.getFormChangesResetRequired();

        if (resetFormData && _.size(this.state.formChanges)) {
            this.setState({ formChanges: {} });
        }
    }

    // Handlers
    public handleEditLookupTableButtonClick(e: any, o: any) {
        // console.log('handleEditLookupTableButtonClick', { e: e, o: o });

        const lookupLink = Formatters.getStr(o, 'lookupLink');
        switch (lookupLink) {
            // case (LK.LookupKeys.Regions): {
            //     this.props.navigateTo(NavigationLinks.defaultManagers());
            //     break;
            // }

            default: {
                this.props.navigateTo(NavigationLinks.lookupTableEdit(Formatters.getStr(o, 'lookupLink')));
                break;
            }
        }
    }

    // Helpers
    public getFormChangesResetRequired() {
        let resetFormData = false;
        // Props values
        const pa = Formatters.getInt(this.props, 'regionId');

        // Cached values
        const ca = Formatters.getInt(this.originalFormDataCache, 'regionId');

        // Determine if formdata state and cache needs reset due to changing associd or invid
        if (pa && ca) {
            resetFormData = (pa !== ca) ? true : false;
        }

        return resetFormData;
    }

    // Renderers
    public renderLookupTables(formData: any) {
        let lookupTables = _(formData.lookupTables)
            .orderBy(['name'], ['asc'])
            .map((c) => {
                return (
                    <div className="lookup-tables-table-container" key={`lookup-tables-table-container-${c.name}`}>
                        <div className="lookup-tables-table-wrapper">
                            <div>
                                <div className="lookup-tables-table-name">
                                    <i className="fa fa-cogs lookup-tables-table-name-glyph" aria-hidden="true" /> {c.name}
                                </div>
                                <hr className="lookup-tables-hr" />
                            </div>
                            <div className="lookup-tables-table-description">
                                {Formatters.getStr(c, 'description')}
                            </div>
                            <Row>
                                <Col xs={2}><div /></Col>
                                <Col xs={8}>
                                    <div className="lookup-tables-table-button text-center">
                                        <Button block={true} bsStyle="info" onClick={(e) => { this.handleEditLookupTableButtonClick(e, c); }}>
                                            <i className="fa fa-database" aria-hidden="true" /> {this.appText('configure')}
                                        </Button>
                                    </div>
                                </Col>
                                <Col xs={2}><div /></Col>
                            </Row>
                        </div>
                    </div>
                );
            })
            .value();

        return (
            <WhiteBoxPageSection {...this.kendoFormWhiteBoxSectionProps} title={this.appText('system-configuration')}>
                {lookupTables}
            </WhiteBoxPageSection>
        );
    }

    public render() {
        const pageTitle = this.appTextPageTitle('page-title', true);
        const lookupTableTextContextPrefix: string = 'tables.textContents.';

        const buildLookupTableObj = (nameAppTextPath: string, descriptionAppTextPath: string, lookupLink: string) => {
            let result = _.merge({}, {
                name: this.appText(nameAppTextPath),
                description: this.appText(descriptionAppTextPath),
                lookupLink: lookupLink,
            });

            return result;
        };

        const composeTableAppTextPath = (appTextPath: string, appTextPathPrefix: string = 'tables', appTextPathSuffix: string = '') => {
            let result = _.join([appTextPathPrefix, appTextPath, appTextPathSuffix], '.');
            return result;
        };

        const composeNameAppTextPath = (nameAppTextPath: string, appTextPathPrefix: string = 'tables', appTextPathSuffix: string = 'table-title') => {
            let result = composeTableAppTextPath(nameAppTextPath, appTextPathPrefix, appTextPathSuffix);
            return result;
        };

        const composeDescAppTextPath = (descAppTextPath: string, appTextPathPrefix: string = 'tables', appTextPathSuffix: string = 'table-description') => {
            let result = composeTableAppTextPath(descAppTextPath, appTextPathPrefix, appTextPathSuffix);
            return result;
        };

        const buildLookupTableConfig = (name: string, lookupKey: string) => {
            let result = buildLookupTableObj(composeNameAppTextPath(name), composeDescAppTextPath(name), lookupKey);
            return result;
        };

        const formData = {
            lookupTables: [
                buildLookupTableConfig('textContents', LK.LookupKeys.TextContents),
                buildLookupTableConfig('associationTypes', LK.LookupKeys.AssociationTypes),
                buildLookupTableConfig('clientTypes', LK.LookupKeys.ClientTypes),
                buildLookupTableConfig('roofTypes', LK.LookupKeys.RoofTypes),
                buildLookupTableConfig('fencingTypes', LK.LookupKeys.FencingTypes),
                buildLookupTableConfig('sidingTypes', LK.LookupKeys.SidingTypes),
                buildLookupTableConfig('securedTypes', LK.LookupKeys.SecuredTypes),
                buildLookupTableConfig('recRoomTypes', LK.LookupKeys.RecRoomTypes),
                buildLookupTableConfig('componentCategories', LK.LookupKeys.ComponentCategories),
                buildLookupTableConfig('componentLocations', LK.LookupKeys.ComponentLocations),
                buildLookupTableConfig('components', LK.LookupKeys.Components),
                // buildLookupTableConfig('inventoryTemplates', composeDescAppTextPath('inventoryTemplates', LK.LookupKeys.InventoryTemplates),
                buildLookupTableConfig('regions', LK.LookupKeys.Regions),
                buildLookupTableConfig('replacementCostTypes', LK.LookupKeys.ReplacementCostTypes),
                buildLookupTableConfig('userResumes', LK.LookupKeys.UserResumes),
                buildLookupTableConfig('serviceLevels', LK.LookupKeys.ServiceLevels),
                buildLookupTableConfig('groupComponentsStandardEvaluations', LK.LookupKeys.GroupComponentsStandardEvaluations),
                buildLookupTableConfig('statusLevels', LK.LookupKeys.StatusLevels),
                buildLookupTableConfig('replacementCosts', LK.LookupKeys.ReplacementCosts),
            ],
        };

        const page = (
            <div className="lookup-tables-page-container">
                {this.renderLookupTables(formData)}
            </div>
        );

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...this.props}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrl = (props) => {
    const regionId = _.get(props, 'match.params.regionId', '');

    if (!regionId) { return ''; }

    return ApiEndpoints.getEditRegionUrl(regionId);
};

const mapPropsToConfigs = (props) => {
    const regionId = _.get(props, 'match.params.regionId', '');

    if (!regionId) { return null; }

    return ReduxQueries.Queries.getEditRegionDetailRequest(
        getApiUrl(props),
        ReduxQueries.PropsAccessToken(props),
    );
};

const mapStateToProps = (state, props) => {
    const regionId = _.get(props, 'match.params.regionId', 0);

    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(props), state, props, {
        regionId: regionId,
        regionDetailRegion: state.entities.editRegionDetailRegion,
        regionDetailRegionOffices: state.entities.editRegionDetailRegionOffices,
        users: state.entities.editRegionDetailUsers,
        offices: state.entities.editRegionDetailOffices,
    });
};

const mapDispatchToProps = {
    updateRegion: MutateActions.updateRegionMutateAsync,
    navigateTo: (path) => push(path),
};

const LookupTablesContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(LookupTables);

export default withRouter(LookupTablesContainer);



// WEBPACK FOOTER //
// ./src/lookup-tables/index.tsx